"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  font-family: ", ";\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 1px;\n  background-color: #e4e4e4;\n  z-index: -9;\n  margin-top: -2px;\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n  position: relative;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  height: 2px;\n  background-color: #ff8000;\n  left: ", ";\n  width: ", ";\n  transition: 0.3s ease-out;\n  margin-top: -2px;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  font-weight: ", ";\n  cursor: pointer;\n  font-size: 1.6rem;\n  text-align: center;\n  padding: 2rem 0;\n  width: ", ";\n  margin-left: ", ";\n  border-bottom: 2px solid rgba(0, 0, 0, 0);\n  text-transform: capitalize;\n  &:hover {\n    font-weight: 700;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Tabs = function Tabs(_ref) {
  var _navigationList$curre, _navigationList$curre2, _navigationList$curre3, _navigationList$curre4;

  var defaultActive = _ref.defaultActive,
      onSelect = _ref.onSelect,
      children = _ref.children;

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var navigationList = (0, _react.useRef)(null);
  var currentActiveClientRect = navigationList === null || navigationList === void 0 ? void 0 : (_navigationList$curre = navigationList.current) === null || _navigationList$curre === void 0 ? void 0 : (_navigationList$curre2 = _navigationList$curre.children) === null || _navigationList$curre2 === void 0 ? void 0 : (_navigationList$curre3 = _navigationList$curre2.namedItem(active)) === null || _navigationList$curre3 === void 0 ? void 0 : _navigationList$curre3.getBoundingClientRect();
  var currentActiveClientRectParent = navigationList === null || navigationList === void 0 ? void 0 : (_navigationList$curre4 = navigationList.current) === null || _navigationList$curre4 === void 0 ? void 0 : _navigationList$curre4.getBoundingClientRect();
  (0, _react.useEffect)(function () {
    setDefaultTabActive();
  }, []);

  function setDefaultTabActive() {
    var tabName;

    if (defaultActive) {
      tabName = defaultActive;
    } else {
      var _Children$toArray = _react.Children.toArray(children),
          _Children$toArray2 = _slicedToArray(_Children$toArray, 1),
          firstChild = _Children$toArray2[0];

      var props = firstChild.props;
      tabName = props === null || props === void 0 ? void 0 : props.name;
    }

    setActive(tabName);
  }

  (0, _react.useEffect)(function () {
    if (active) {
      onSelect(active);
    }
  }, [active]);
  return _react.default.createElement(TabContainer, null, _react.default.createElement(SelectorContainer, null, _react.default.createElement(LinkList, {
    ref: navigationList
  }, _react.Children.toArray(children).map(function (child) {
    var props = child.props;
    return (0, _react.cloneElement)(child, {
      active: props.name === active,
      onClick: function onClick() {
        return setActive(props.name);
      }
    });
  })), _react.default.createElement(Selector, {
    left: (currentActiveClientRect === null || currentActiveClientRect === void 0 ? void 0 : currentActiveClientRect.left) - (currentActiveClientRectParent === null || currentActiveClientRectParent === void 0 ? void 0 : currentActiveClientRectParent.left) || 1,
    width: (currentActiveClientRect === null || currentActiveClientRect === void 0 ? void 0 : currentActiveClientRect.width) + 2 || 0
  }), _react.default.createElement(DividerLine, null)));
};

Tabs.defaultProps = {
  defaultActive: undefined,
  onSelect: function onSelect() {}
};
Tabs.propTypes = {
  /** only for Tabs.Item */
  name: _propTypes.string.isRequired,

  /** Dont set on Tabs.Item this is only for internal usage */
  active: _propTypes.bool,

  /** Dont set on Tabs.Item this is only for internal usage */
  onClick: _propTypes.func,
  defaultActive: _propTypes.string,
  children: _propTypes.node.isRequired,
  onSelect: _propTypes.func
};

var Tab = function Tab(_ref2) {
  var name = _ref2.name,
      rightAlign = _ref2.rightAlign,
      children = _ref2.children,
      active = _ref2.active,
      onClick = _ref2.onClick,
      width = _ref2.width;
  return _react.default.createElement(Item, {
    onClick: onClick,
    name: name,
    rightAlign: rightAlign,
    active: active,
    width: width
  }, children);
};

Tab.defaultProps = {
  rightAlign: false,
  active: false,
  onClick: function onClick() {},
  width: '12rem'
};
Tab.propTypes = {
  width: _propTypes.string,
  name: _propTypes.string.isRequired,
  rightAlign: _propTypes.bool,
  children: _propTypes.node.isRequired,
  active: _propTypes.bool,
  onClick: _propTypes.func
};

var Item = _styledComponents.default.li(_templateObject(), function (props) {
  return props.active ? 700 : 500;
}, function (props) {
  return props.width;
}, function (props) {
  return props.rightAlign ? 'auto' : 'inherit';
});

var LinkList = _styledComponents.default.ul(_templateObject2());

var Selector = _styledComponents.default.div(_templateObject3(), function (props) {
  return props.left ? "".concat(props.left, "px") : 'inherit';
}, function (props) {
  return props.width ? "".concat(props.width, "px") : 'inherit';
});

var SelectorContainer = _styledComponents.default.div(_templateObject4());

var DividerLine = _styledComponents.default.div(_templateObject5());

var TabContainer = _styledComponents.default.nav(_templateObject6(), function (_ref3) {
  var theme = _ref3.theme;
  return theme.font;
});

Tabs.Item = Tab;
Tabs.Item.displayName = 'Tabs.Item';
var _default = Tabs;
exports.default = _default;